import { useEffect } from "react"

export function useEffectAsync(effect: () => Promise<any>, variables: any[] | undefined, cleanUp?: () => void) {
  useEffect(() => {
    effect().catch((e) => {
      console.warn(" error", e)
      throw e
    })
    return () => {
      !!cleanUp && void cleanUp()
    }
  }, variables)
}
